// eslint-disable-next-line import/no-anonymous-default-export
export default { type: "spring", mass: 0.5 };
